<template lang="pug">
  .b-change Чек-лист обновлен
</template>

<script>
export default {
  name: 'TaskChangeChecklist',
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">

</style>
